<div class="directionContainer flex-with-center" *ngIf="showDirections" @fadeSlide>
    <div class="download-button2" *ngIf="poiLoading">
        <span class="loader"></span>
    </div>

    <div *ngIf="!poiLoading" class="flex-with-center" style="gap: 5px;width: 100%">
        <div class="customSelectDiv">
            <div style="height: 30px;width:100%;">            
                <app-custom-multi-select
                    #customFromMultiSelect
                    [options]="directionOptionsFrom"
                    (selectionChange)="onSelectionFrom($event)"
                    [initialOptionsText]="fromFirstOption"
                    [isMulti]="false"
                    [disable]="false"
                ></app-custom-multi-select>
            </div>
            <i class="fa fa-map-marker directionIcon"
               [ngStyle]="{ color: poiService.getChooseFromInMap() ? 'red' : 'black' }"
               (click)="chooseFromInMap()"></i>
        </div>        
        <i class="fa fa-exchange" style="transform: rotate(90deg);"></i>
        <div class="customSelectDiv">
            <div style="height: 30px;width:100%;">
            <app-custom-multi-select
                #customToMultiSelect
                [options]="directionOptionsTo"
                (selectionChange)="onSelectionTo($event)"
                [initialOptionsText]="toFirstOption"
                [isMulti]="false"
                [disable]="disableTo"
            ></app-custom-multi-select>
            </div>
            <i class="fa fa-map-marker directionIcon" [ngStyle]="{ color: poiService.getChooseToInMap() ? 'red' : 'black' }"  (click)="chooseToInMap()"></i>
        </div>
    </div>

    <div *ngIf="routeSegment" style="width: 95%;margin-top: 5px">
        <div>
            <span style="font-size: 14px;color: #5b5b98;font-weight: 600"
                  [matTooltip]="routeSegment?.name">{{ routeSegment?.name | slice:0:35 }}</span>
            <span style="font-size: 14px;color: #5b5b98;font-weight: 600"
                  *ngIf="routeSegment?.name?.length > 35">...</span>
        </div>
        <div>
            <span
                style="font-size: 14px;color: #5b5b98;font-weight: 900">{{ formatDistance(routeSegment?.distance) }} </span>
            <span> , </span>
            <span
                style="font-size: 14px;color: #5b5b98;font-weight: 900">{{ formatDuration(routeSegment?.duration) }} </span>
        </div>
    </div>
</div>